<template><v-card tile>
    <div id="centroNuevo">
      <v-toolbar card dark color="teal lighten-2">
      <v-toolbar-title>{{ mcursod.nombre }} Horario: {{ mcursod.fecha_inicio}} AL {{mcursod.fecha_fin}} ({{mcursod.hora_inicio}} A {{mcursod.hora_fin}})</v-toolbar-title>
      <v-toolbar-items></v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="$emit('close')">Cerrar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <h4 class="grey--text text--darken-1"> 
              <v-icon small color="primary">drag_indicator</v-icon> Registro de Nota del Curso
            </h4>
          </v-flex>
        </v-layout>
        <v-card>
          
          <v-card-text>
            <v-form ref="form_nota">
              <v-layout row wrap>
                <v-flex xs12 class="my-0 py-0">
                  <v-card-title class="grey lighten-4 py-1 px-1">
                    <h3 class="grey--text text--darken-1">Participante Inscrito</h3>
                  </v-card-title>
                  <v-divider class="mb-0"></v-divider>
                </v-flex>

                <v-flex xs8 class="py-0">
                  <v-select
                    :items="minscur"
                    label="Participante"
                    item-text="nomcomp"
                    item-value="id"
                    v-model="evaluacion.id_par"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                
                <v-flex xs12 class="my-0 py-0">
                  <v-card-title class="grey lighten-4 py-1 px-1">
                    <h4 class="grey--text text--darken-1">Registro de la calificación final del curso</h4>
                  </v-card-title>
                  <v-divider class="mb-0"></v-divider>
                </v-flex>

                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="number"
                    label="Nota numeral"
                    v-model.trim="evaluacion.notanum"
                    :rules="[v => !!v && v <= 100 && v > 0 || 'Ingrese la nota entre 1 y 100' ]"
                    required
                    @keyup="Centenas(evaluacion.notanum)"
                  ></v-text-field>
                </v-flex>

                <v-flex xs8 class="py-0">
                  <v-text-field
                    type="text"
                    label="Nota literal"
                    v-model="evaluacion.notalit"
                    :rules="[v => !!v || 'Ingrese el dato']"
                    class="txt-upper"
                    readonly
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
            <div class="text-xs-center mt-3">
              <v-btn color="primary" dark @click="confirmInscrip">Guardar</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
      
      <v-dialog v-model="mconfirm" width="300">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Alerta</span>
          </v-card-title>
          <v-card-text class="text-xs-center">
            {{ mensaje }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loadingBtnSend" v-if="hide_accept" color="success darken-1" flat @click="createInscrip">
              Aceptar
            </v-btn>
            <v-btn color="blue darken-1" flat @click="mconfirm = false">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2500"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </div> 
  </v-card>
  </template>
  <script>
  /* eslint-disable no-console */
  import Service from "../services/general";
  import axios from "axios";
  export default {
    name: "centro-nuevo",
    props: ['mcodigo', 'mcursod', 'minscur', 'mloading'],
    data() {
      return {
       
        loading: false,
        color_txt: '',
        hide_accept: true,
        loadingBtnSend: false,
        
        evaluacion: {
          id_par: '',
          notanum: '',
          notalit: ''
        },

        mconfirm: false,
        size_width: 0,
        mensaje: '',
        dparams: {},
        snack: {
          state: false,
          color: 'success',
          mode: '',
          text: ''
        }
      };
    },
    mounted() {
      this.dparams = Service.getParams();
      if (this.dparams && this.dparams.roluser != Service.rol().director) {
        this.$router.push({name: 'principal'});
      }

      this.$refs.form_nota.reset();
      
      this.getExpedidos(1);
      
    },
    methods: {
      

    getExpedidos(pais_id) {
      Service.expedidos(pais_id).then(response => {
        this.departamentosE = response.data;
      })
      .catch(error => {
        console.error("Error al cargar datos", error);
      });
    },
      
    confirmInscrip() { 
        if (this.$refs.form_nota.validate()) {
          this.color_txt = 'grey';
          this.loadingBtnSend = false;
          this.hide_accept = true;
          this.mensaje = '¿Está seguro(a) de registrar la inscripción del participante con la información ingresada?';
          this.mconfirm = true;
        } else {
          this.toast('warning', 'Debe completar los datos del formulario de manera correcta.');
        }
      },
      createInscrip() {
      
      this.mconfirm = false;

      axios
        .post(Service.getBase() + "guarda/nota", this.evaluacion, Service.getHeader())
        .then(response => {
          //this.loadingSegip = false;
          if (response.data.estado == 200) {
            //this.getFacilitadores();
            this.$refs.form_nota.reset();
            this.mdialog = false;
            this.toast("success", "Registro guardado.");
          } else {
            this.toast("warning", response.data.msg);
          }
        })
        .catch(error => {
          this.loadingSegip = false;
          this.toast("error", "No se pudo guardar " + error);
        });
    },
      
      toast(color, text) {
        this.snack.color = color;
        this.snack.text = text;
        this.snack.state = true;
      },

Unidades(num){ 
num=parseInt(num);
switch(num)
{
    case 1: return 'UNO'; break;
    case 2: return 'DOS'; break;
    case 3: return 'TRES'; break;
    case 4: return 'CUATRO'; break;
    case 5: return 'CINCO'; break;
    case 6: return 'SEIS';break;
    case 7: return 'SIETE';break;
    case 8: return 'OCHO';break;
    case 9: return 'NUEVE';break;
    return '';
}
},//Unidades()
Decenas(num){
  num=parseInt(num);
var decena = Math.floor(num/10);
var unidad = num - (decena * 10);

switch(decena)
{
    case 1:
        switch(unidad)
        {
            case 0: this.evaluacion.notalit=  'DIEZ';break;
            case 1: this.evaluacion.notalit=  'ONCE';break;
            case 2: this.evaluacion.notalit=  'DOCE';break;
            case 3: this.evaluacion.notalit=  'TRECE';break;
            case 4: this.evaluacion.notalit=  'CATORCE';break;
            case 5: this.evaluacion.notalit=  'QUINCE';break;
            default: this.evaluacion.notalit=  'DIECI' + this.Unidades(unidad);break;
        };break;
    case 2:
        switch(unidad)
        {
            case 0: this.evaluacion.notalit=  'VEINTE';break;
            default: this.evaluacion.notalit=  'VEINTI' + this.Unidades(unidad);break;
        };break;
    case 3: this.evaluacion.notalit=  this.DecenasY('TREINTA', unidad);break;
    case 4: this.evaluacion.notalit=  this.DecenasY('CUARENTA', unidad);break;
    case 5: this.evaluacion.notalit=  this.DecenasY('CINCUENTA', unidad);break;
    case 6: this.evaluacion.notalit=  this.DecenasY('SESENTA', unidad);break;
    case 7: this.evaluacion.notalit=  this.DecenasY('SETENTA', unidad);break;
    case 8: this.evaluacion.notalit=  this.DecenasY('OCHENTA', unidad);break;
    case 9: this.evaluacion.notalit=  this.DecenasY('NOVENTA', unidad);break;
    case 0: this.evaluacion.notalit=  this.Unidades(unidad);break;
}
},//Unidades()

DecenasY(strSin, numUnidades) {
if (numUnidades > 0){
return strSin + ' Y ' + this.Unidades(numUnidades)
}else{
  return strSin;
}

},//DecenasY()

Centenas(num) { 
  num=parseInt(num);
var centenas = Math.floor(num / 100); 
var decenas = num - (centenas * 100);

switch(centenas)
{ 
    case 1:
        this.evaluacion.notalit= 'CIEN'; break;
    case 0: this.Decenas(decenas);
}


}//Centenas()
      
    }
  };
  </script>